export class DepositMainModel {
    label_title: string;
    label_bonus: string;
    label_payment_method: string;
    constructor() {
        this.label_title = "Add funds";
        this.label_bonus = "Select your bonus offer";
        this.label_payment_method = "Select your payment method";
    }
}

export class CasinoCageModel {
    label_title: "Add funds";
    label_bonus: "Select your bonus offer";
    label_payment_method: "Casino Cage";
    label_description_title: "";
    default_amt_1: "";
    label_description: "<p>To make a direct deposit into your account from inside the Casino simply go to the Cashier and give them the amount you want to deposit, your Driver's License and the email address you used to access your account. The funds you deposit will be available immediately.</p><p>It's that easy!</p>";
    label_w_note_success: "casino cage"
}

export class CreditCardModel {
    label_title: "Add funds";
    label_bonus: "Select your bonus offer";
    label_payment_method: "Credit & Debit card";
    label_description_title: "MasterCard Recommended";
    label_description: "We recommend MasterCard as many Visa card issuing banks do not allow these types of transactions. Enter Your Card Information, Your Billing Address and Press 'Submit'.";
    label_deposit_button: "Deposit";
    label_payment_title: "Amount";
    label_address: "Address";
    label_city: "City";
    label_state: "State";
    label_country: "Country"
    label_zipcode: "Zip code";
    label_message: "If your billing address is different from below, please enter it now";
    label_message_2: "To prevent fraud, your payment card’s billing address must match your address on file below. If your address is incorrect, please";
    label_text: "What is CVV Code?";
    label_input: "Name on the Card"
    label_input_1: "Select a Credit/Debit card";
    label_input_2: "Use a different card";
    label_input_3: "Card Type";
    label_input_4: "Card Number";
    label_input_5: "Expiry Month";
    label_input_6: "Expiry Year";
    label_input_7: "CVV Code";
}

export class MazoomaModel {
    label_title: "Add funds";
    label_bonus: "Select your bonus offer";
    label_payment_method: "Online Banking";
    label_description_title: "";
    label_description: "";
}

export class PayNearMeModel {
    label_title: "Add funds";
    label_bonus: "Select your bonus offer";
    label_payment_method: "PayNearMe";
    label_description_title: "Please Note:";
    label_description: "<p><strong>Deposit limit:</strong> 24 hr max: $500, 30 day max: $10,000</p><div style=\"font-size: 14px;\"><p><a href=\"https://home.paynearme.com\" target=\"_blank\">PayNearMe</a> lets you make deposits with cash at 7-Eleven or Family Dollar stores nationwide.</p><p>To use PayNearMe, select it as your funding method and follow the screen prompts to generate a barcode and payment instructions. You can either print out the barcode or display it on your mobile phone.</p><p>You then present the barcode, along with your cash, to complete the transaction at a participating <a href=\"https://home.paynearme.com/locations/\" target=\"_blank\">7-Eleven or Family Dollar.</a></p></div>";
}

export class PayPalModel {
    label_title: "Add funds";
    label_bonus: "Select your bonus offer";
    label_payment_method: "PayPal";
    label_description_title: "Please Note:";
    label_description: "<p>This option requires to turn off the \"Block Pop-ups\" option in the browser settings</p>";
}

export class PrePaidCardsModel {
    label_title: "Add funds";
    label_bonus: "Select your bonus offer";
    label_payment_method: "Prepaid Card";
    label_description_title: "Please Note:";
    label_description: "<ul><li>Multiple Ways to Fund Visa, Mastercard, Discover, Pay With My Bank, and PayPal</li><li> Instant deposits to your account</li><li>Fast cash-outs</li><li>Freedom to spend at retail and ATM's</li><li>Once enrolled select \"Add funds\" to add funds your Prepaid Card account</li></ul>";
}

export class VipPreferredModel {
    label_title: "Add funds";
    label_bonus: "Select your Bonus Offer";
    label_payment_method: "ACH/E-Check";
    label_payment_title: "Amount";
    label_description_title: "";
    label_description: "It is quick and easy to enroll in the VIP Preferred Program. Fill out this one-time form and click Submit.";
    label_description_title2: "";
    label_description2: "";
    label_deposit_button: "Deposit";
    label_input: "Use a different account to deposit";
    label_input_1: "Personal Information";
    label_input_2: "ID Type";
    label_input_3: "ID Number";
    label_input_4: "Confirm ID Number";
    label_input_5: "State";
    label_input_6: "Banking Information";
    label_input_7: "Routing Number";
    label_input_8: "Account Number";
    label_input_9: "Where to find banking information?";
}

export class PayWithMyBankModel { 
    label_title: "Add funds";
    label_bonus: "Select your bonus offer";
    label_payment_method: "PayWithMyBank";
    label_description_title: "PayWithMyBank TITLE";
    label_description: "PayWithMyBank DESCRIPTION";
}

export class CommonModel {
  label_title: "";
  label_bonus: "";
  label_payment_method: "";
  label_title_all: "Select another deposit method";
  label_title_limits: "Set your deposit limits";
}

export class WireModel {
    label_title: "Add funds";
    label_bonus: "";
    label_payment_method: "Wire Transfer";
    label_title_all: "Select another deposit method";
    label_title_limits: "Set your deposit limits";
    label_column_1: "";
    label_column_1_bold: "";
    label_column_2: "";
    label_column_1_end: "";
    label_reference: "";
    label_important_1: "";
    label_important_2: "";
    label_important_3: "";
    label_faq: "";
    label_faq_path: "";
    label_customer_support: "";
}
